import Content from './Content';

const index = {
  Content,
};

export default index;